import React from 'react';

/**
 * Renders text with "@Name" mention tokens (as inserted by MentionTextField) bolded.
 * Purely visual — it doesn't resolve or link to the tagged user/group, since the
 * displayed text only carries a name, not the id MentionTextField recorded separately.
 */
const MENTION_PATTERN = /@[A-Za-z0-9][\w'-]*(?:\s[A-Z][\w'-]*)*/g;

const MentionText: React.FC<{ text: string }> = ({ text }) => {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  MENTION_PATTERN.lastIndex = 0;
  while ((match = MENTION_PATTERN.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index));
    parts.push(
      <strong key={match.index} style={{ color: 'inherit' }}>{match[0]}</strong>
    );
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));

  return <>{parts}</>;
};

export default MentionText;
